import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SnrFieldConfig, SnrFieldConfigRequest } from '../../../../shared/models/generated/ziroModels';

@Injectable()
export class SnrFieldConfigResource {
  private http = inject(HttpClient);

  getFieldConfigs(request: SnrFieldConfigRequest): Observable<SnrFieldConfig> {
    return this.http.post<SnrFieldConfig>(`/services/cisco/field-configs/snrs`, request);
  }
}
